<template>
  <div>
    <a-card>
      <div class="ant-descriptions-title">
        Lịch sử hoạt động
      </div>
      <!-- <a-steps progress-dot :current="0" direction="vertical">
        <a-step v-for="i in lichSuHoatDong" :key="i.id">
          <a-card size="small" slot="description">
            {{ i.Title }} - {{ i.CreatedAt }}
          </a-card>
        </a-step>
      </a-steps> -->
      <i> chưa có làm </i>
    </a-card>
  </div>
</template>
<script>
import queryData from "@/services/queryData.js";
export default {
  props: {},
  data() {
    return { datas: [], lichSuHoatDong: [] };
  },
  methods: {
    getListData() {
      const { idNghiPhep } = this.$route.params;
      queryData
        .get("/HoatDongNghiPheps?_sort=id&_order=desc&NghiPhepId=" + idNghiPhep)
        .then(({ data }) => {
          this.datas = [...data];
        })
        .catch((error) => {
          console.log("Lỗi thêm mới: ", error);
        });
    },
  },
  created() {
    // this.getListData();
  },
};
</script>
<style lang="css" scoped>
.ant-steps >>> .ant-steps-item-content {
  width: auto !important;
}
</style>
